module.exports = __webpack_public_path__ + "static/media/About.3e767b4f.svg";